/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_System_SourceInputs */

const en_notifications_system_source = /** @type {(inputs: Notifications_System_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const pt_br2_notifications_system_source = /** @type {(inputs: Notifications_System_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Notifications_System_SourceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_system_source = /** @type {((inputs?: Notifications_System_SourceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_System_SourceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_system_source(inputs)
	return pt_br2_notifications_system_source(inputs)
});